<template>
  <div>
    <loading :loading="!equipamento" />
    <div v-if="equipamento" class="row">
      <div class="col-sm-12 col-md-6">
        <div class="row pl-4" style="align-items: baseline">
          <div @click="$router.back()">
            <md-icon>keyboard_backspace</md-icon>
          </div>
          <div class="pl-3">
            <p class="md-title" style="margin: 0">
              {{ equipamento.nome }}
            </p>
            <p class="md-caption" style="margin: 0.1rem 0 0; font-size: 0.9rem">
              {{ localName }}
            </p>
          </div>
          <div class="ml-2">
            <FlowChip
              :value="equipamentoStatus.severity"
              :config="{
                0: { label: 'Ativo', color: '#4CAF50' },
                1: { label: 'Aviso', color: '#FF9800' },
                2: { label: 'Travado', color: '#F44336' },
              }"
            />
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="row" style="justify-content: flex-end">
          <md-button v-if="admin" class="md-primary" @click="dadoAvulso = true">
            <md-icon>add</md-icon>
            Adicionar Valor
          </md-button>

          <md-button
            v-if="admin"
            class="md-primary"
            @click="baixarDados = true"
          >
            <md-icon>download</md-icon>
            Baixar dados
          </md-button>
        </div>
      </div>
    </div>
    <div>
      <md-tabs v-if="equipamento" class="pt-0" md-sync-route>
        <md-tab
          id="tab-painel"
          md-label="Painel"
          exact
          :to="`/local/${localId}/equipamento/${equipamentoId}/editar`"
        >
          <EquipamentoPainelRelacionamento
            :equipamento="equipamento"
            :local-id="localId"
            :equipamento-id="equipamentoId"
            :equipamento-status="equipamentoStatus"
            @show-sensor="
              ({ sensor, status }) =>
                (slider = {
                  open: true,
                  type: 'show-sensor-data',
                  data: { sensor, status },
                  // Get with based on media query
                  size: getWidth('30%', '80%'),
                })
            "
            @show-notificacao="
              (notificacao) =>
                (slider = {
                  open: true,
                  type: 'show-notificacao-data',
                  data: { notificacao },
                  size: getWidth('47%', '90%'),
                })
            "
          />
        </md-tab>

        <md-tab
          id="tab-analise"
          md-label="Análise"
          :to="`/local/${localId}/equipamento/${equipamentoId}/editar/analise`"
        >
          <ShowEquipamentoGraficos :equipamento-id="equipamentoId" />
        </md-tab>

        <md-tab
          v-if="
            equipamento &&
            equipamento.equipamentoConfigTipo === 1 &&
            canCmdAuto()
          "
          id="tab-config-moto-bomba"
          md-label="Moto bomba"
          :to="`/local/${localId}/equipamento/${equipamentoId}/editar/moto-bomba`"
        >
          <EquipamentoMotoBombaConfig
            :equipamento="equipamento"
            @update="() => loadData()"
          />
        </md-tab>

        <md-tab
          v-if="canEquipamentoEditar()"
          id="tab-audit"
          md-label="Auditoria"
          :to="`/local/${localId}/equipamento/${equipamentoId}/editar/auditoria`"
        >
          <EquipamentoAuditoria @open-history="handleOpenHistory" />
        </md-tab>

        <md-tab
          id="tab-configuracao"
          md-label="Configuração"
          :to="`/local/${localId}/equipamento/${equipamentoId}/editar/configuracao`"
        >
          <EquipamentoConfiguracaoTab
            :local-id="localId"
            :equipamento="equipamento"
            @change="() => loadData()"
          />
        </md-tab>
      </md-tabs>
    </div>

    <new-slider-right
      :is-open="slider.open"
      :size="slider.size || '47%'"
      @closed="slider.open = false"
    >
      <equipamento-historico-acao
        v-if="slider.open && slider.type === 'historico-acao'"
        :acao-id="slider.data.acaoId"
        :equipamento-id="equipamentoId"
        @close="slider.open = false"
      />

      <show-sensor-data
        v-if="slider.open && slider.type === 'show-sensor-data'"
        :sensor="slider.data.sensor"
        :status="slider.data.status"
        :local-id="localId"
        :equipamento-id="equipamentoId"
        @close="slider.open = false"
        @delete="(e) => handleChangeSensores()"
      />

      <show-notificacao-data
        v-if="
          slider.open &&
          slider.type === 'show-notificacao-data' &&
          equipamentoId
        "
        :notificacao="slider.data.notificacao"
        :equipamento-id="equipamentoId"
        :local-id="localId"
        @close="slider.open = false"
      />
    </new-slider-right>

    <md-dialog :md-active.sync="dadoAvulso" :md-fullscreen="true">
      <md-dialog-content>
        <EquipamentoSelecionarSensor
          v-if="dadoAvulso"
          :equipamento-id="equipamentoId"
        />
      </md-dialog-content>
    </md-dialog>

    <md-dialog :md-active.sync="baixarDados" :md-fullscreen="true">
      <md-dialog-content>
        <EquipamentoDownloadCsv
          v-if="baixarDados"
          :equipamento-id="equipamentoId"
        />
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import EquipamentoConfiguracaoTab from '@/components/equipamento/EquipamentoConfiguracaoTab.vue'
import EquipamentoDownloadCsv from '@/components/equipamento/EquipamentoDownloadCsv.vue'
import EquipamentoHistoricoAcao from '@/components/equipamento/EquipamentoHistoricoAcao.vue'
import EquipamentoMotoBombaConfig from '@/components/equipamento/EquipamentoMotoBombaConfig.vue'
import EquipamentoPainelRelacionamento from '@/components/equipamento/EquipamentoPainelRelacionamento.vue'
import EquipamentoSelecionarSensor from '@/components/equipamento/EquipamentoSelecionarSensor.vue'
import ShowEquipamentoGraficos from '@/components/equipamento/graficos/ShowEquipamentoGraficos.vue'
import FlowChip from '@/components/FlowChip.vue'
import Loading from '@/components/Loading.vue'
import NewSliderRight from '@/components/NewSliderRight.vue'
import ShowNotificacaoData from '@/components/notificacao/ShowNotificacaoData.vue'
import ShowSensorData from '@/components/sensor/ShowSensorData.vue'
import store from '@/store'
import auth from '@/utils/auth'
import {
  registerChannelListener,
  removeChannelListener,
} from '@/utils/web-socket'

import EquipamentoAuditoria from '../../components/equipamento/EquipamentoAuditoria'
import EquipamentoChangeCredentials from '../../components/equipamento/EquipamentoChangeCredentials'
import http from '../../utils/http'

export default {
  name: 'EquipamentoEditar',
  components: {
    FlowChip,
    EquipamentoConfiguracaoTab,
    ShowEquipamentoGraficos,
    ShowNotificacaoData,
    ShowSensorData,
    EquipamentoSelecionarSensor,
    EquipamentoDownloadCsv,
    EquipamentoPainelRelacionamento,
    EquipamentoHistoricoAcao,
    NewSliderRight,
    EquipamentoMotoBombaConfig,
    Loading,
    EquipamentoAuditoria,
    EquipamentoChangeCredentials,
  },
  mixins: [validationMixin],
  data() {
    return {
      slider: {
        open: false,
        type: '',
        data: null,
      },
      editandoAcao: false,
      editandoAcaoIndex: false,
      equipamentoId: null,
      localId: null,
      equipamento: null,
      equipamentoUsuario: null,
      sensores: [],
      // acao editando
      editanto: false,
      sending: false,
      telefoneValido: false,
      listeningCalibracaoRef: null,
      listeningConfiguracaoGeralRef: null,
      dadoAvulso: false,
      baixarDados: false,
      equipamentoStatus: null,
    }
  },
  computed: {
    localName: function () {
      if (this.$route.params.localId) {
        return store.state.locais[this.$route.params.localId]?.nome
      }

      return null
    },
    admin: function () {
      return auth.isAdmin()
    },
  },
  beforeMount() {
    this.equipamentoId = this.$route.params.equipamentoId
    this.localId = this.$route.params.localId
  },
  async mounted() {
    await this.loadData()

    await this.startListeningCalibracao()
  },
  async beforeDestroy() {
    await this.stopListeningCalibracao()
  },
  methods: {
    canCmdAuto: auth.canCmdAuto.bind(auth),
    canCalibracao: auth.canCalibracao.bind(auth),
    canEquipamentoEditar: auth.canEquipamentoEditar.bind(auth),
    async getStatus() {
      return (
        await http.get(`equipamento/${this.equipamentoId}/status-travado`)
      ).equipamento
    },
    getWidth(defaultWidth, mobile) {
      return window.innerWidth > 768 ? defaultWidth : mobile
    },
    handleOpenHistory(event) {
      this.slider = {
        open: true,
        type: event.type,
        data: event.data,
      }
    },
    handleVoltar() {
      if (this.equipamento) {
        this.$router.push({
          name: 'LocalDetalhe',
          params: { localId: this.equipamento.localId },
          query: { e: this.equipamento.id },
        })
        return
      }

      this.$router.back()
    },
    startListeningCalibracao() {
      this.listeningCalibracaoRef = registerChannelListener(
        `calibracao_equipamento:${this.equipamentoId}`,
        'calibracao:update',
        (data) => {
          this.handleStatusCalibracao(data.sensorId, data.status)
        }
      )

      this.listeningConfiguracaoGeralRef = registerChannelListener(
        `config_geral_equipamento:${this.equipamentoId}`,
        'config:update',
        (data) => {
          this.handleStatusConfiguracaoGeral(data.configuracao, data.status)
        }
      )
    },
    stopListeningCalibracao() {
      removeChannelListener(
        `calibracao_equipamento:${this.equipamentoId}`,
        'calibracao:update',
        this.listeningCalibracaoRef
      )
      removeChannelListener(
        `config_geral_equipamento:${this.equipamentoId}`,
        'config:update',
        this.listeningConfiguracaoGeralRef
      )
    },
    async loadData() {
      this.equipamento = null
      this.equipamentoUsuario = null
      this.sensores = []

      this.$forceUpdate()

      const [data, status] = await Promise.all([
        http.get(`equipamento/${this.$route.params.equipamentoId}`),
        this.getStatus(),
      ])

      this.form = {
        ...this.form,
        ...data.equipamento,
      }

      this.equipamentoStatus = status
      this.equipamento = data.equipamento

      this.equipamentoUsuario = data.equipamento.usuario

      this.sensores = data.equipamento.sensores

      // Para ativar a mascara do vue js...
      setInterval(() => {
        this.$forceUpdate()
      }, 100)

      // this.$refs.sensores.setData(this.equipamentoId);
    },
    handleChangeSensores() {
      this.equipamento = null

      this.slider.open = false

      this.loadData()
    },
    handleStatusConfiguracaoGeral(tipo, status = 0) {
      this.equipamento = {
        ...this.equipamento,
        config: this.equipamento.config.map((e) => ({
          ...e,
          config: {
            ...e.config,
            status: e.configName === tipo ? status : e.config.status,
          },
        })),
      }
    },
    handleStatusCalibracao(id, status = 0) {
      const getStatus = (sensor, id, status) => {
        if (id) {
          if (sensor.id === id) {
            return status
          }
          return sensor.calibracao.status
        }

        return status
      }

      this.equipamento = {
        ...this.equipamento,
        sensores: this.equipamento.sensores.map((e) => ({
          ...e,
          calibracao: {
            ...e.calibracao,
            status: getStatus(e, id, status),
          },
        })),
      }
    },
  },
}
</script>

<style lang="scss" itemscope>
div.md-tabs-navigation.md-elevation-0 {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;

  max-width: 60%;
}
</style>
